import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"
import { api } from "@/lib/api"

const userSchema = z.object({
  telegram_id: z.string().min(1, "Telegram ID is required"),
  username: z.string().optional(),
  first_name: z.string().min(1, "First name is required"),
  last_name: z.string().optional(),
  role: z.enum(["user", "admin", "super_admin"]),
  status: z.enum(["active", "banned", "inactive"]),
})

const userColumns = [
  { key: "telegram_id", type: "text", options: { label: "Telegram ID" } },
  { key: "username", type: "text", options: { label: "Username" } },
  { key: "first_name", type: "text", options: { label: "First Name" } },
  { key: "role", type: "status", options: { label: "Role" } },
  { key: "status", type: "status", options: { label: "Status" } },
  { key: "created_at", type: "date", options: { label: "Created" } },
]

const userFormFields = [
  { name: "telegram_id", label: "Telegram ID", type: "text", placeholder: "Enter Telegram ID" },
  { name: "username", label: "Username", type: "text", placeholder: "Enter username" },
  { name: "first_name", label: "First Name", type: "text", placeholder: "Enter first name" },
  { name: "last_name", label: "Last Name", type: "text", placeholder: "Enter last name" },
  {
    name: "role",
    label: "Role",
    type: "select",
    options: [
      { value: "user", label: "User" },
      { value: "admin", label: "Admin" },
      { value: "super_admin", label: "Super Admin" },
    ],
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "active", label: "Active" },
      { value: "banned", label: "Banned" },
      { value: "inactive", label: "Inactive" },
    ],
  },
]

function UsersPage() {
  return (
    <ResourcePage
      resource="users"
      title="Users"
      columns={userColumns}
      formFields={userFormFields}
      formSchema={userSchema}
    />
  )
}

export default UsersPage
